<template>
  <div class="form-group">
    <input
      :class="className"
      :type="type"
      :value="value"
      :name="name"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
    >
    <!-- <i v-if="hasIcon" class="input-icon" :class="classIcon"></i> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      className: 'text-input'
    }
  },
  props: {
    value: {
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    classIcon: {
      type: String,
      required: false,
      default: ''
    },
    hasIcon: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: String,
      required: false,
      default: ''
    },
    verifiyError: {
      required: false
    }
  },
  watch: {
    verifiyError: function (val) {
      if (val === true) {
        this.className = 'text-input-error'
        this.$emit('resetClass', this.className)
      } else {
        this.className = 'text-input'
        this.$emit('resetClass', this.className)
      }
    }
  }
}
</script>

<style scoped>
.form-group > .input-icon {
  position: absolute;
  margin-top: 10px;
  /* color: #1ed9ba; */
}

.text-input {
  border-width: 0;
  border-style: solid;
  background-color: #fdf3ea;
  outline: 0;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  color: #6b6764;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-input:focus {
  border-color: #ff6501;
  border: 1px solid #ff6501;
  border-left-width: 7px;
  padding-left: 28px;
}
.text-input-error {
  margin-bottom: 10px;
  height: 40px;
  border: 1px solid #e99191;
  border-left: 1px solid #ff0000;
  background-color: #f3dada;
  outline: 0;
  border-left-width: 7px;
  padding-left: 28px;
  color: #d16e6e;
}
.text-input-error:focus {
  border: 1px solid #ff0000;
  border-left-width: 7px;
  padding-left: 28px;
}
</style>
